export default __webpack_public_path__ + "static/media/ico-trash-yellow.25fc6a83.svg";